module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_6000.d6b83a75.png";